<pl-ul
  *ngIf="block"
  [label]="block.data.label"
  [showMoreButtonAtStart]="block.data.config.showMoreButtonAtStart"
  [minItemsDisplayed]="block.data.config.minItemsDisplayed"
  [items]="items()"
/>
